import(/* webpackMode: "eager", webpackExports: ["NoticeTable"] */ "/app/src/features/notice-listing/ui/notice-table.tsx");
